/**
 * Copyright 2020 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const getMachineStateReport = `mutation MachineStateReport($input: MachineStateReportInput!,) {
    sendMachineStateReport(input: $input)
  }
  `;
